module.exports = __webpack_public_path__ + "img/it_seguropatinete.b7803feb.svg";